// JS
import React, { useRef, useLayoutEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import ReactDOMServer from 'react-dom/server';

// SCSS
import './_storylyCustom.scss';

const Storyly = ({
  storylyToken,
  storylyHeading,
  showHeading,
  storylyOptions
}) => {
  //const [globalState] = useGlobal();
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const CustomContent = () => (
    <div className="custom-story-group-container">
      <div className="custom-story-group">
        <div
          className="storyly__story-preview"
          onError={
            'https://g2.img-dpreview.com/C7E98764B33A491FB5130BBDBB17E78C.jpg'
          }
        ></div>
        <img className="storyly__story-group-cover" alt="Story Cover" />
        <span className="storyly__story-group-pin">
          <span className="icon"></span>
        </span>
      </div>
      <span className="storyly__story-group-title" />
    </div>
  );

  const html = ReactDOMServer.renderToStaticMarkup(<CustomContent />);

  const storylyRef = useRef();
  useLayoutEffect(() => {
    if (storylyRef.current && storylyRef.current.init) {
      storylyRef.current.init({
        token: storylyToken,
        customStoryGroupHTML: html
      });
    }
  }, [storylyToken, html]);

  return (
    <section
      id="storyly"
      className={
        'container my-6 md:my-12' +
        (storylyOptions?.classes ? ' ' + storylyOptions.classes : '')
      }
    >
      <div className="storyly-content">
        {showHeading && isMobile && (
          <h2 className="storyly-heading">{storylyHeading}</h2>
        )}
        <div className="storyly-custom">
          <storyly-web ref={storylyRef} customStoryGroupHTML />
        </div>
      </div>
    </section>
  );
};

export default Storyly;
